import useNamespacedLocalStorage from 'app/hooks/useNamespacedLocalStorage';

export const usePersistedLocation = () => {
  return useNamespacedLocalStorage('ostroPersistedLocation', '');
};
